export default __webpack_public_path__ + "static/media/2.d0eb384a.jpg";